import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { profile } from "../actions/auth";
import LoginPrompt from "../components/loginprompt/LoginPrompt";

/**
 * Start: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Start screen module which redirects logged in users to
 * the dashboards and otherwise displays a login prompt.
 *
 * @param {*} props
 */
const Start = props => {
  if (!props.isAuthenticated) {
    return <LoginPrompt />;
  }
  return <Redirect to="/agenda" />;
};

function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.user.uid,
    userName: state.user.username
  };
}

Start.propTypes = {
  /**
   * isAuthenticated: Boolean
   * True if the user is currently logged in
   */
  isAuthenticated: PropTypes.bool.isRequired
};

export default connect(
  mapStateToProps,
  { profile }
)(Start);



// WEBPACK FOOTER //
// ./src/modules/Start.js